import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringShorten'
})
export class StringShortenPipe implements PipeTransform {

  transform(text: string | undefined, maxLength: number): string {
    if (text == undefined) return '';
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '…';
  }

}
